import { render, staticRenderFns } from "./DrawTwo.vue?vue&type=template&id=f0647590&scoped=true&"
import script from "./DrawTwo.vue?vue&type=script&lang=js&"
export * from "./DrawTwo.vue?vue&type=script&lang=js&"
import style0 from "./DrawTwo.vue?vue&type=style&index=0&id=f0647590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0647590",
  null
  
)

export default component.exports